<template>
  <div>
    <v-row>
      <v-col cols="12" md="9" class="py-0 py-md-2">
        <v-autocomplete
          v-model="filterStore.tags"
          :items="tagItems"
          :search-input.sync="searchAuto"
          chips
          deletable-chips
          :label="$t('home.search.tags.placeholder')"
          item-text="name"
          item-value="id"
          multiple
          return-object
          solo
          auto-select-first
          :no-data-text="$t('home.search.tags.noData')"
          hide-selected
          hide-details
          @change="searchAuto = ''"
          :menu-props="{ value: openmenu }"
        >
          <!-- @input="onTagSelected" -->
          <template v-slot:item="{ item }">
            <template v-if="typeof item !== 'object'">
              <v-list-item-content v-text="item"></v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-content>
                <v-list-item-title v-html="item.name"></v-list-item-title>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" class="py-2">
        <v-checkbox
          :label="$t('home.search.showOnlyNewProducts')"
          class="white rounded mt-0 ml-1 pl-2 py-3"
          hide-details
          v-model="filterStore.onlyNewProduct"
        />
      </v-col>
    </v-row>
    <div class="black--text mt-3">
      <v-row class="position-relative">
        <v-col cols="12" sm="6" md="3" class="py-0 py-md-2">
          <multi-category-selector-component
            v-model="filterStore.category"
            :items="lookupStore.combinedCategoriesWithAllOption"
          />
        </v-col>
        <v-col cols="12" sm="6" md="3" class="py-0 py-md-2">
          <v-select
            :items="lookupStore.colors"
            v-model="filterStore.color"
            label=""
            item-text="text"
            return-object
            solo
            class="pl-1"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="py-0 py-md-2">
          <v-select
            :items="lookupStore.types"
            v-model="filterStore.type"
            label=""
            item-text="name"
            return-object
            solo
            class="pl-1"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="py-0 py-md-2">
          <v-select
            :items="vendorItems"
            v-model="filterStore.vendor"
            label=""
            item-text="name"
            return-object
            solo
            class="pl-1"
          ></v-select>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useLookupStore } from '../../../stores/LookupStore';
import { useFilterStore } from '../../../stores/FilterStore';
import { useSearchStore } from '../../../stores/SearchStore';
import MultiCategorySelectorComponent from '../../../components/common/MultiCategorySelectorComponent.vue';

export default {
  components: {
    MultiCategorySelectorComponent,
  },

  data() {
    return {
      searchAuto: '',
      openmenu: false,
      unsubscribeFilterStore: undefined,
      cat: null,
    };
  },

  mounted() {
    this.unsubscribeFilterStore = this.filterStore.$subscribe((x, y) => {
      // If the search values are the same as the previous search, don't search again
      // This is to prevent unnecessary API calls when changing language
      if (!this.searchStore.isSearchChanged()) {
        return;
      }

      this.searchStore.reset();
      this.searchStore.search(true);
    });

    // används när man har kommit tillbaka från en route tex bakåtknappen från nyheter osv.
    // this.filterStore.reset();
  },

  destroyed() {
    this.unsubscribeFilterStore();
  },

  computed: {
    ...mapStores(useLookupStore, useFilterStore, useSearchStore),

    tagItems() {
      return this.sortTagsByTerm(this.lookupStore.tags, (this.searchAuto || '').toLocaleLowerCase());
    },

    vendorItems() {
      return this.lookupStore.vendorsWithAllOption;
    },
  },

  watch: {
    searchAuto(val) {
      this.openmenu = !!val;

      val && val !== this.filterStore.tags && this.queryTagSelections(val);
    },
  },

  methods: {
    sortTagsByTerm(data, term) {
      return data.sort(function (a, b) {
        return a.name.toLocaleLowerCase().indexOf(term) < b.name.toLocaleLowerCase().indexOf(term) ? -1 : 1;
      });
    },

    queryTagSelections(v) {
      this.items = this.lookupStore.tags.filter((e) => {
        return (e || { name: '' }).name.toLocaleLowerCase().indexOf((v || '').toLocaleLowerCase()) > -1;
      });
    },
  },
};
</script>
